import { useEffect, useRef, useState } from 'react';

export const LOCAL_STORAGE_NAMES = {
    AAD_PARTNER_APPLICATION_DATA: 'AADPartnerApplicationData',
};

export function useLocalStorageState(
    key: string,
    defaultValue: (() => string) | string = '',
    { serialize = JSON.stringify, deserialize = JSON.parse } = {}
): [string | boolean, React.Dispatch<React.SetStateAction<string | boolean>>] {
    const [state, setState] = useState<string | boolean>(() => {
        const valueInLocalStorage = window.localStorage.getItem(key);
        if (valueInLocalStorage) {
            try {
                return deserialize(valueInLocalStorage);
            }
            catch (err) {
                window.localStorage.removeItem(key);
            }
        }
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    });

    const prevKeyRef = useRef(key);

    useEffect(() => {
        const prevKey = prevKeyRef.current;
        if (prevKey !== key) {
            window.localStorage.removeItem(prevKey);
        }
        prevKeyRef.current = key;
        window.localStorage.setItem(key, serialize(state));
    }, [key, state, serialize]);

    return [state, setState];
}

export default useLocalStorageState;
